export default __webpack_public_path__ + "img/component-info-card.4186db69.png";